import { ExamContentElement } from "lib/common/models/exam";
import React, { FC, useRef, useState } from "react";
import { Container, Row, Col, Input, ListGroup, ListGroupItem, Button } from "reactstrap";


type QuestionSelectorProps = {
    listOfContents: ExamContentElement[];
    currentContent: ExamContentElement;
    onSelectQuestion: (question: ExamContentElement) => void;
};

const QuestionSelector: FC<QuestionSelectorProps> = ({ listOfContents, currentContent, onSelectQuestion }) => {
    const [selectedQuestion, setSelectedQuestion] = useState<ExamContentElement>();
    const [searchQuery, setSearchQuery] = useState("");

    /**
     * Replaces current content to show preview and
     * @param content
     */
    function onSelectContent(content: ExamContentElement) {
        setSelectedQuestion(content);
    }


    // Filtrar preguntas por título
    const filteredContents = listOfContents.filter((content) =>
        content.questionName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <Container fluid>
        <Row className="justify-content-center">
            <div className="mt-3">
                <Button
                    disabled={!selectedQuestion}
                    onClick={() => onSelectQuestion(selectedQuestion as ExamContentElement)}
                    className="btn-round btn btn-info"
                >
                Accept selection
                </Button>
                <Button
                    className="btn-round btn btn-danger"
                    onClick={() => onSelectQuestion(currentContent)}
                >
                Close
                </Button>
            </div>
        </Row>
        <hr></hr>
        <Row className="justify-content-center">
          <Col md="4" className="p-3 border-end">
            <h4 style={{textAlign: 'center', marginTop: '0'}}>Select a question</h4>
            <Input
              type="text"
              placeholder="Search by name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ marginBottom: "10px" }}
            />
            <ListGroup style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {filteredContents.map((content) => (
                <ListGroupItem  onClick={() => onSelectContent(content)}
                style={{ border: selectedQuestion?.questionName === content.questionName ? '2px solid green' : '1px solid #ddd' }}
                key={content.questionId} action>
                  <p>
                    <strong>Name:</strong> {content.questionName}
                  </p>
                  <p>
                    <strong>Topic:</strong> {content.topicName}
                  </p>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>
          <Col md="8" className="p-3">
            <h4 style={{textAlign: 'center', marginTop: '0'}}>Preview {selectedQuestion ? `with ${selectedQuestion.questionName}`: ''}</h4>
            <div
              dangerouslySetInnerHTML={{ __html: selectedQuestion?.html as string }}
            />
          </Col>
        </Row>
      </Container>
    );
  };

  export default QuestionSelector;
